import NavigationMobile from './navigationMobile';

export default class Navigation {

  constructor(el) {
    let mm = gsap.matchMedia();
    mm.add("(max-width: 1199px)", () => {
      new NavigationMobile(el);
    });
  }
}
